
import { Component, Inject, Vue } from "vue-property-decorator";
import { FeedbackModalStore, FeedbackModalType } from "./FeedbackModalStore";
import { Container } from "inversify";

@Component
export default class ProvideFeedback extends Vue {
    @Inject("container") readonly container!: Container;
    feedbackModalStore: FeedbackModalStore = this.container.get(FeedbackModalStore);

    get FeedbackModalType() {
        return FeedbackModalType;
    }
}
